export const CommunicationEmailAudience = {
    MANAGER: 'manager',
    EMPLOYEE: 'employee',
} as const;

export type CommunicationEmailAudienceValue =
    (typeof CommunicationEmailAudience)[keyof typeof CommunicationEmailAudience];
